<div
    *ngIf="collection && resourcesInCollection.length > 0 && !isAddonView"
    class="selenium-more-from-collection"
>
    <h4 class="selenium-more-from-collection-header mb-3 mb-lg-1" style="margin: 0 0 0 15px">
        More from the {{ collection.title }} Collection
    </h4>
    <div class="row-auto more-from-container">
        <div class="collection-card">
            <span
                title="{{ collection.title }}"
                attr.aria-label="Open collection {{ collection.title }}"
                class="gtm-resource-more-from-collection"
            >
                <app-collection-card [learningObject]="collection"></app-collection-card>
            </span>
        </div>
        <div
            *ngFor="let resource of resourcesInCollection"
            class="selenium-resource-more-from-collection more-resource"
        >
            <span>
                <app-mfr-card [learningObject]="resource" [gtmPrefix]="gtmPrefix"></app-mfr-card>
            </span>
        </div>
    </div>
    <div class="row-auto collection-button-wrapper">
        <div class="collection-button">
            <app-link
                [appRouterLink]="getRoute(collection)"
                title="See the collection"
                attr.aria-label="Open collection"
                class="btn gtm-resource-see-collection selenium-see-collection"
                >See the Collection</app-link
            >
        </div>
    </div>
</div>
